import { apiForPrivate } from '.';
import { TRANSFORMER_SCRIPT_ENDPOINT } from '../../config/ap';

const apiScriptMaps = apiForPrivate.injectEndpoints({

  overrideExisting: true,
  
  endpoints: build => ({
    getTransformerScript: build.query({
      query: clientId => `${TRANSFORMER_SCRIPT_ENDPOINT.SCRIPTS}?clientId=${clientId}`,
    }),
    testTransformerScript: build.mutation({
      query: (payload) => ({
        url: TRANSFORMER_SCRIPT_ENDPOINT.TEST,
        method: 'POST',
        body: payload,
      }),
    }),
    saveTransformerScript: build.mutation({
      query: (payload) => ({
        url: TRANSFORMER_SCRIPT_ENDPOINT.SCRIPTS,
        method: 'POST',
        body: payload,
      }),
    }),
    
  })
});

export const {
  useLazyGetTransformerScriptQuery,
  useSaveTransformerScriptMutation,
  useTestTransformerScriptMutation,
} = apiScriptMaps;